import useSeo from "@/lib/useSeo";
import LegalPage from "@/components/marketing/LegalPage";
import { TERMS, TERMS_META } from "@/content/terms";

export default function Terms() {
  useSeo({ title: "Terms and Conditions", description: "ChangeOS terms and conditions of use for organisations, consultancies and their members.", path: "/terms" });
  return <LegalPage meta={TERMS_META} sections={TERMS} testid="terms-page" contactIntro="For any questions or legal inquiries regarding these Terms and Conditions, please contact us at:" />;
}
